import api from '../api';
import { NavigationResponse } from '../../types/AllyNavigationTypes';

export const fetchNavigationItems = async (): Promise<NavigationResponse> => {
  try {
    const response = await api.get('/Menu', {
      headers: {
        'content-type': 'application/json',
      },
    });

    if (response && response.data) {
      return response.data as NavigationResponse;
    } else {
      console.warn('No data received from API, returning empty navigation');
      return createEmptyNavigationResponse();
    }
  } catch (error) {
    console.warn('Error fetching navigation data from API, returning empty navigation:', error);
    return createEmptyNavigationResponse();
  }
};

// Create an empty but valid navigation response
const createEmptyNavigationResponse = (): NavigationResponse => {
  return {
    menu: [
      {
        name: 'mainSidebar',
        items: [],
        footers: [],
        updatedAt: null,
        id: '',
        createdBy: null,
        createdOnDate: null,
        lastModifiedBy: null,
        lastModifiedDate: null,
      },
    ],
    result: {
      status: false,
      value: 'No navigation data available',
    },
    errorCode: '404',
  };
};
